import React from 'react'
import styled from 'styled-components'
import { DashboardLayout, DefaultLayout } from '../../layouts'
import { PricingPageContent } from './PricingPageContent'
import { useAuth } from '../../auth/useAuth'
import { Content } from '../Dashboard/components'

export const PricingScreen = () => {
  const { user } = useAuth()
  return (
    <>
      {!user && (
        <DefaultLayout>
          <PricingPageContent />
        </DefaultLayout>
      )}
      {user && (
        <DashboardLayout>
          <StyledContent
            title='Pricing'
            titleContainerProps={{ style: { zIndex: 1 } }}
          >
            <StyledPricing />
          </StyledContent>
        </DashboardLayout>
      )}
    </>
  )
}

const StyledContent = styled(Content)`
  .main-content {
    margin: -94px -56px 0;

    @media (max-width: 920px) {
      margin: -94px -16px 0;
    }
  }
`

const StyledPricing = styled(PricingPageContent)`
  margin: 0;
  padding: 56px 0 0;
  background: #ffffff;
`
